<template>
  <div>
    <c-tab
      type="horizon"
      :dense="true"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
      :height="tabHeight"
    >
      <template v-slot:default="tab">
        <chem-components
          :is="tab.component"
          :param="popupParam"
          @insertOutletInfo="updateMode"
        />
      </template>
    </c-tab>
  </div>
</template>
<script>
export default {
  name: 'gov-schedule-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        envAirMstOutletId: '',
        tabName: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'govScheduleInfo',
      tabItems: [
        { name: 'govScheduleInfo', icon: 'info', label: '대기 배출구(방지시설) 기본정보', class:"tab-orange", component: () => import(`${'./airMaster01Info.vue'}`) },
      ],
      addTabItems: [
        { name: 'govScheduleHistory', icon: 'construction', label: '방지시설 부품/이력 관리', component: () => import(`${'./airMaster01Part.vue'}`) },
      ]
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  watch: {
  },
  methods: {
    init() {
      if (this.popupParam.tabName) {
        this.tab = this.popupParam.tabName;
      }
      if (this.popupParam.envAirMstOutletId != '') {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    updateMode(_envAirMstOutletId) {
      this.popupParam.envAirMstOutletId = _envAirMstOutletId;
      this.tabItems = this.tabItems.concat(this.addTabItems);
    },
  }
};
</script>